import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-invitation-email-form",
  templateUrl: "./invitation-email-form.component.html",
  styleUrls: ["./invitation-email-form.component.scss"],
})
export class InvitationEmailFormComponent implements OnInit {
  @Input() initialEmail = "";

  @Output() emailSubmit = new EventEmitter<string>();

  public form: FormGroup;

  constructor(private readonly fb: FormBuilder) {
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]],
    });
  }

  /**
   * Pre-fills the email field with the initial email, if one was given.
   */
  ngOnInit(): void {
    if (this.initialEmail) {
      this.form.patchValue({
        email: this.initialEmail,
      });
    }
  }

  /**
   * Validates the form and emits the entered email, or marks every field as touched to show
   * its errors when invalid.
   */
  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.emailSubmit.emit(this.form.get("email")?.value);
  }
}
